/* eslint-disable no-console */

export const attachmentUrl = (awsConnectContactId, id) => `/ai/aws_connect/chatkit_attachments/${id}?aws_connect_contact_id=${awsConnectContactId}`;

export const fetchTranscript = async (awsConnectContactId) => {
  try {
    const res = await fetch(`/ai/aws_connect/chatkit_transcript?aws_connect_contact_id=${awsConnectContactId}`, {
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
    });
    if (!res.ok) return [];
    const data = await res.json();
    return data.transcript;
  } catch (error) {
    console.error('Error fetching AWS Connect transcript:', error);
    return [];
  }
};

export const sendMessage = async (awsConnectContactId, content) => {
  try {
    const formData = new FormData();
    formData.append('aws_connect_contact_id', awsConnectContactId);
    formData.append('content', content);

    const res = await fetch('/ai/aws_connect/chatkit_messages', {
      method: 'POST',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: formData
    });
    if (!res.ok) return { ok: false, messageId: null };
    const data = await res.json();
    return { ok: true, messageId: data.message_id || null };
  } catch (error) {
    console.error('Error sending AWS Connect message:', error);
    return { ok: false, messageId: null };
  }
};

export const fetchWebsocketUrl = async (awsConnectContactId) => {
  try {
    const res = await fetch(`/ai/aws_connect/chatkit_participant_connection?aws_connect_contact_id=${awsConnectContactId}`, {
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.websocket_url;
  } catch (error) {
    console.error('Error fetching websocket URL:', error);
    return null;
  }
};

export const refreshWebsocketUrl = async (awsConnectContactId) => {
  try {
    const res = await fetch('/ai/aws_connect/chatkit_participant_connection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ aws_connect_contact_id: awsConnectContactId })
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data.websocket_url;
  } catch (error) {
    console.error('Error creating websocket URL:', error);
    return null;
  }
};

export const sendAttachment = async (awsConnectContactId, file) => {
  try {
    const formData = new FormData();
    formData.append('aws_connect_contact_id', awsConnectContactId);
    formData.append('attachment', file);

    const res = await fetch('/ai/aws_connect/chatkit_attachments', {
      method: 'POST',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: formData
    });
    if (!res.ok) return { ok: false, attachmentId: null };
    const data = await res.json();
    return { ok: true, attachmentId: data.attachment_id || null };
  } catch (error) {
    console.error('Error sending AWS Connect attachment:', error);
    return { ok: false, attachmentId: null };
  }
};
